import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20floating%20books%20and%20manuscripts%20in%20a%20dreamy%20sky%2C%20soft%20cream%20and%20warm%20beige%20color%20palette%2C%20feathers%20and%20ink%20bottles%20drifting%20gently%2C%20abstract%20geometric%20patterns%20in%20the%20background%2C%20conceptual%20art%20about%20writing%20and%20creativity%2C%20ethereal%20and%20inspiring%20atmosphere&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="Po文网站推荐 - 原创内容发布平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
          找到最适合你的
          <br />
          <strong className="text-primary-300">po文网站</strong>
        </h1>
        <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          精选多款主流原创内容发布平台，涵盖注册流程、发布技巧、流量变现与读者互动策略，
          帮助创作者快速找到适合自己的创作家园，轻松开启内容创作之旅。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            浏览全部平台
          </Link>
          <Link
            to="/article/top-10-powen-platforms-2026"
            className="px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            查看推荐榜单
          </Link>
        </div>
      </div>
    </section>
  );
}